import { ComplianceStatus } from '@src/meta/types/compliance';
import { SentinelUser } from '../../types/user';

export default function isUserNotCompliant(user: SentinelUser | undefined): boolean {
  const complianceStatus = user?.complianceStatus;

  if (complianceStatus !== undefined) {
    return (
      complianceStatus === ComplianceStatus.MATCH ||
      complianceStatus === ComplianceStatus.POTENTIAL_MATCH
    );
  }
  return false;
}
